var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResidenceDonSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.73,137.85l-17.15-18V96.19s-1.25-6.06-6.87-5.76-7.18,3.94-7.18,6.06v32.13l24,27,.31,30.3H94.3V148.32s1.79-5.64-7.81-15.76c-8.07-8.53-23-28.59-30.84-19.2M142,137.85l17.16-18V96.19s1.24-6.06,6.86-5.76,7.19,3.94,7.19,6.06v32.13l-24,27-.32,30.3H120.42V148.32s-1.79-5.64,7.8-15.76c8.08-8.53,23-28.59,30.85-19.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.82,83.2h0v28h-33v-28h0a16.5,16.5,0,0,1,16.43-15.79S123,67.33,123.84,83.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.34,42.37a12,12,0,1,0,12-12A12,12,0,0,0,95.34,42.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidenceDonSupport);
export default __webpack_public_path__ + "static/media/RESIDENCE_DON_SUPPORT.e2127bec797482954afe932fcaa4b32f.svg";
export { ForwardRef as ReactComponent };